import React from 'react';

import { FormattedMessage } from 'react-intl';

import LockIcon from '@atlaskit/icon/core/lock-locked';
import Lozenge from '@atlaskit/lozenge/new/lozenge';
import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { messages } from './messages';

const container = xcss({
	display: 'inline-flex',
	alignItems: 'center',
	gap: 'space.050',
	backgroundColor: 'color.background.neutral',
	paddingLeft: 'space.100',
	paddingRight: 'space.150', // different to paddingLeft for visual balance
	paddingTop: 'space.025',
	paddingBottom: 'space.025',
	borderRadius: 'radius.small',
	cursor: 'default', // so that it doesn't change to the text-selecting looking one
});

const iconColor = token('color.icon');

type Restriction = 'restricted' | 'private';
interface RestrictedLozengeProps {
	restriction: Restriction;
}

export const LOZENGE_TEST_ID = 'restricted-lozenge';

export const RestrictedLozenge = ({ restriction }: RestrictedLozengeProps): React.JSX.Element => {
	const label = restriction === 'private' ? messages.privateLabel : messages.restrictedLabel;
	const tooltipText =
		restriction === 'private' ? messages.privateTooltip : messages.restrictedTooltip;

	if (fg('confluence_fronend_labels_categorization_migration')) {
		return (
			<Tooltip content={<FormattedMessage {...tooltipText} />}>
				<Lozenge appearance="neutral" iconBefore={LockIcon} testId={LOZENGE_TEST_ID}>
					<FormattedMessage {...label} />
				</Lozenge>
			</Tooltip>
		);
	}

	return (
		<Tooltip content={<FormattedMessage {...tooltipText} />}>
			<Box xcss={container} testId={LOZENGE_TEST_ID}>
				<LockIcon label="" color={iconColor} size="small" />

				<Text color="color.text">
					<FormattedMessage {...label} />
				</Text>
			</Box>
		</Tooltip>
	);
};
